export default __webpack_public_path__ + "media/images/icons/icon-search-66db68d9b209975935e004b0172e6a00.svg";